import './Message.css';
import { ReactComponent as SuccessIcon } from '../../assets/icons/sucess_icon.svg';
import { ReactComponent as ErrorIcon } from '../../assets/icons/error_icon.svg';

function Message({ type = 'success', message }) {
  const Icon = type === 'success' ? SuccessIcon : ErrorIcon;

  return (
    <div className={`message-toast ${type}`}>
      <Icon className="toast-icon" />
      <span>{message}</span>
    </div>
  );
}

export default Message;